/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApplyProtocolCreateApplyRequest {
  businessType?: MarqCommonEnumsClientBusinessType;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  countryClassList: FolioCoreModelCtrySubClassIdInfo[];
  email?: string | null;
  language: MarqCommonEnumsLanguageEnum;
  newCountries?: string | null;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber?: string | null;
  reference?: FolioCoreModelApTmReferenceDto;
  trademark?: FolioCommonModelTrademarkDto;
}

export interface ApplyProtocolCreateApplyResponse {
  /** @format int32 */
  id: number;
}

export interface ApplyProtocolCreateDesignRightRequest {
  businessType?: MarqCommonEnumsClientBusinessType;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  countryList: FolioCommonEnumsFolioCountryCodeEnum[];
  email?: string | null;
  imageName?: string | null;
  imageUrl?: string | null;
  language: MarqCommonEnumsLanguageEnum;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber?: string | null;
}

export interface ApplyProtocolCreateDesignRightResponse {
  /** @format int32 */
  apDrId: number;
}

export interface ApplyProtocolGetApplyRequest {
  /** @format int32 */
  id: number;
}

export interface ApplyProtocolGetApplyResponse {
  businessType?: MarqCommonEnumsClientBusinessType;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  countryClassList: FolioCoreModelCtrySubClassIdInfo[];
  description?: string | null;
  discounts?: FolioCommonModelDiscountDataDiscount[] | null;
  email?: string | null;
  /** @format int32 */
  id: number;
  isAddedProtectionPlan?: boolean | null;
  newCountries?: string | null;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber?: string | null;
  reference?: FolioCoreModelApTmReferenceDto;
  trademark?: FolioCommonModelTrademarkDto;
}

export interface ApplyProtocolGetClassListResponse {
  classList: FolioCoreModelApClassDto[];
}

export interface ApplyProtocolGetCountryListResponse {
  countryList: FolioCommonModelCountryPriceDtoCountry[];
  freqSelectedList: FolioCommonEnumsFolioCountryCodeEnum[];
}

export interface ApplyProtocolGetCountryPriceResponse {
  countryPriceList: FolioCommonModelCountryPriceDto[];
}

export interface ApplyProtocolGetDesignRightSupportCountryListResponse {
  countryList: ApplyProtocolGetDesignRightSupportCountryListResponseCountryPrice[];
}

export interface ApplyProtocolGetDesignRightSupportCountryListResponseCountryPrice {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  /** @format double */
  price: number;
}

export interface ApplyProtocolGetDrImagePresignedDownloadUrlRequest {
  url: string;
}

export interface ApplyProtocolGetDrImagePresignedDownloadUrlResponse {
  url: string;
}

export interface ApplyProtocolGetDrImagePresignedUrlRequest {
  filename: string;
}

export interface ApplyProtocolGetDrImagePresignedUrlResponse {
  url: string;
}

export interface ApplyProtocolGetRefFilePresignedDownloadUrlRequest {
  url: string;
}

export interface ApplyProtocolGetRefFilePresignedDownloadUrlResponse {
  url: string;
}

export interface ApplyProtocolGetRefFilePresignedUrlRequest {
  filename: string;
  /** @format int32 */
  tmId?: number | null;
}

export interface ApplyProtocolGetRefFilePresignedUrlResponse {
  url: string;
}

export interface ApplyProtocolGetTmImagePresignedDownloadUrlRequest {
  url: string;
}

export interface ApplyProtocolGetTmImagePresignedDownloadUrlResponse {
  url: string;
}

export interface ApplyProtocolGetTmImagePresignedUrlRequest {
  filename: string;
  /** @format int32 */
  tmId?: number | null;
}

export interface ApplyProtocolGetTmImagePresignedUrlResponse {
  url: string;
}

export interface ApplyProtocolSubmitApplyRequest {
  businessType?: MarqCommonEnumsClientBusinessType;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  countryClassList: FolioCoreModelCtrySubClassIdInfo[];
  description?: string | null;
  discounts?: FolioCommonModelDiscountDataDiscount[] | null;
  email?: string | null;
  /** @format int32 */
  id: number;
  isAddedProtectionPlan?: boolean | null;
  language: MarqCommonEnumsLanguageEnum;
  newCountries?: string | null;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneCountry: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber: string;
  reference?: FolioCoreModelApTmReferenceDto;
  referralCode?: string | null;
  trademark?: FolioCommonModelTrademarkDto;
  updateInfo: boolean;
}

export interface ApplyProtocolSubmitDesignRightRequest {
  /** @format int32 */
  apDrId: number;
}

export interface ApplyProtocolSubmitDesignRightResponse {
  /** @format int32 */
  apDrId: number;
}

export interface ApplyProtocolUpdateApplyRequest {
  businessType?: MarqCommonEnumsClientBusinessType;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  countryClassList: FolioCoreModelCtrySubClassIdInfo[];
  description?: string | null;
  email?: string | null;
  /** @format int32 */
  id: number;
  isAddedProtectionPlan?: boolean | null;
  language: MarqCommonEnumsLanguageEnum;
  newCountries?: string | null;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber?: string | null;
  reference?: FolioCoreModelApTmReferenceDto;
  referralCode?: string | null;
  trademark?: FolioCommonModelTrademarkDto;
}

export interface ApplyProtocolUpdateDesignRightRequest {
  /** @format int32 */
  apDrId: number;
  businessType?: MarqCommonEnumsClientBusinessType;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  countryList: FolioCommonEnumsFolioCountryCodeEnum[];
  email?: string | null;
  imageName?: string | null;
  imageUrl?: string | null;
  language: MarqCommonEnumsLanguageEnum;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber?: string | null;
}

export interface ApplyProtocolUpdateDesignRightResponse {
  /** @format int32 */
  apDrId: number;
}

export interface AuthProtocolFindPasswordCheckRequest {
  email: string;
  token: string;
}

export interface AuthProtocolFindPasswordCheckResponse {
  verified: boolean;
}

export interface AuthProtocolFindPasswordResetRequest {
  email: string;
  password: string;
  token: string;
}

export interface AuthProtocolFindPasswordResetResponse {
  accessToken: string;
  refreshToken: string;
}

export interface AuthProtocolFindPasswordSendRequest {
  email: string;
  language: MarqCommonEnumsLanguageEnum;
}

export interface AuthProtocolFindPasswordSendResponse {
  token: string;
}

export interface AuthProtocolFindPasswordVerifyRequest {
  verifyToken: string;
}

export interface AuthProtocolLoginRequest {
  email: string;
  password: string;
}

export interface AuthProtocolLoginResponse {
  accessToken: string;
  refreshToken: string;
}

export interface AuthProtocolRefreshTokenRequest {
  refreshToken: string;
}

export interface AuthProtocolRefreshTokenResponse {
  accessToken: string;
}

export interface AuthProtocolRegisterNewClientRequest {
  businessType?: MarqCommonEnumsClientBusinessType;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  email: string;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  password: string;
  phoneCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber?: string | null;
  referralCode?: string | null;
}

export interface AuthProtocolSignupRequest {
  businessType?: MarqCommonEnumsClientBusinessType;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  email: string;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  password: string;
  phoneCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber?: string | null;
  privacyAgreement?: boolean | null;
  referralCode?: string | null;
  termsAgreement: boolean;
  token: string;
}

export interface AuthProtocolSignupResponse {
  accessToken: string;
  refreshToken: string;
}

export interface AuthProtocolSignupVerifyRequest {
  verifyToken: string;
}

export interface AuthProtocolSignupVerifyCheckRequest {
  email: string;
  token: string;
}

export interface AuthProtocolSignupVerifyCheckResponse {
  verified: boolean;
}

export interface AuthProtocolSignupVerifySendRequest {
  email: string;
  language: MarqCommonEnumsLanguageEnum;
}

export interface AuthProtocolSignupVerifySendResponse {
  token: string;
}

export interface AuthProtocolVerifyEmailRequest {
  email: string;
}

export interface AuthProtocolVerifyEmailResponse {
  isVerified: boolean;
}

export interface HomeProtocolDeleteCardRequest {
  paymentMethodId: string;
}

export interface HomeProtocolGetNotiCountResponse {
  /** @format int32 */
  count: number;
}

export interface HomeProtocolGetProfileResponse {
  businessType?: MarqCommonEnumsClientBusinessType;
  cards: MarqCommonModelCard[];
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  email: string;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber?: string | null;
  referralCode?: string | null;
  secondAppDisc: boolean;
}

export interface HomeProtocolSaveCardRequest {
  card: MarqCommonModelCard;
}

export interface HomeProtocolUpdateProfileRequest {
  businessType: MarqCommonEnumsClientBusinessType;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneCountry: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber: string;
  referralCode?: string | null;
}

export interface PaymentProtocolCalculateAdditionalClientPaymentRequest {
  ctryPackageList: FolioCoreModelCtryPackageForPayReq[];
  /** @format double */
  overallAddDiscount?: number | null;
  /** @format int32 */
  tmId: number;
}

export interface PaymentProtocolCalculateAdditionalClientPaymentResponse {
  tmPricePack: FolioCommonModelTmPricePack;
}

export interface PaymentProtocolCalculateClientPaymentRequest {
  ctryPackageList: FolioCoreModelCtryPackageForPayReq[];
  isAddedProtectionPlan?: boolean | null;
  /** @format double */
  overallAddDiscount?: number | null;
  /** @format int32 */
  tmId: number;
}

export interface PaymentProtocolCalculateClientPaymentResponse {
  tmPricePack: FolioCommonModelTmPricePack;
}

export interface PaymentProtocolConfirmAdditionalCardOkRequest {
  address: FolioCommonModelAddressWithChina;
  billingDetails: FolioCommonModelBillingDetails;
  hasFailed: boolean;
  ownerDetails: PaymentProtocolOwnerDetails;
  /** @format int32 */
  reqId: number;
}

export interface PaymentProtocolConfirmCardOkRequest {
  address: FolioCommonModelAddressWithChina;
  billingDetails: FolioCommonModelBillingDetails;
  ctryPackageList: FolioCoreModelCtryPackageForPayReq[];
  hasFailed: boolean;
  /** @format double */
  overallAddDiscountPercent?: number | null;
  ownerDetails: PaymentProtocolOwnerDetails;
  /** @format int32 */
  reqId: number;
}

export interface PaymentProtocolCreateAdditionalPaymentIntentRequest {
  /** @format int32 */
  reqId: number;
  saveCard: boolean;
}

export interface PaymentProtocolCreateAdditionalPaymentIntentResponse {
  clientSecret: string;
  /** @format int32 */
  orderId: number;
}

export interface PaymentProtocolCreatePaymentIntentRequest {
  /** @format int32 */
  reqId: number;
  saveCard: boolean;
  /** @format double */
  totalPrice: number;
}

export interface PaymentProtocolCreatePaymentIntentResponse {
  clientSecret: string;
  /** @format int32 */
  orderId: number;
}

export interface PaymentProtocolDownloadOrderFormUrlRequest {
  url: string;
}

export interface PaymentProtocolDownloadOrderFormUrlResponse {
  url: string;
}

export interface PaymentProtocolGetAdditionalOrderFormRequest {
  billingDetails: FolioCommonModelBillingDetails;
  billingEmail: string;
  billingName: string;
  ctryPackageList: FolioCoreModelCtryPackageForPayReq[];
  isSigned?: boolean | null;
  /** @format double */
  overallAddDiscount?: number | null;
  /** @format int32 */
  reqId: number;
  signName?: string | null;
  /** @format int32 */
  tmId: number;
}

export interface PaymentProtocolGetAdditionalOrderFormResponse {
  contents: string;
  /** @format int32 */
  reqId: number;
}

export interface PaymentProtocolGetAdditionalPaymentListRequest {
  /** @format int32 */
  tmId: number;
}

export interface PaymentProtocolGetAdditionalPaymentListResponse {
  list: PaymentProtocolGetAdditionalPaymentListResponseAdditionalPaymentList[];
}

export interface PaymentProtocolGetAdditionalPaymentListResponseAdditionalPaymentList {
  countryList: PaymentProtocolGetAdditionalPaymentListResponseByCountry[];
  /** @format int32 */
  tmId: number;
  /** @format double */
  totalPrice: number;
  trademark?: FolioCommonModelTrademarkDto;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  validDate: string;
}

export interface PaymentProtocolGetAdditionalPaymentListResponseByCountry {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  itemList: PaymentProtocolGetAdditionalPaymentListResponsePayItem[];
}

export interface PaymentProtocolGetAdditionalPaymentListResponsePayItem {
  classIdList?: number[] | null;
  invalidTmName?: string | null;
  itemName: string;
  /** @format double */
  price: number;
}

export interface PaymentProtocolGetFirstAddressRequest {
  /** @format int32 */
  tmId: number;
}

export interface PaymentProtocolGetFirstAddressResponse {
  city?: string | null;
  countryCode?: FolioCommonEnumsFolioCountryCodeEnum;
  streetAddress?: string | null;
  /** @format int32 */
  tmId?: number | null;
  zipCode?: string | null;
}

export interface PaymentProtocolGetOrderFormRequest {
  billingDetails: FolioCommonModelBillingDetails;
  billingEmail: string;
  billingName: string;
  ctryPackageList: FolioCoreModelCtryPackageForPayReq[];
  isSigned?: boolean | null;
  /** @format double */
  overallAddDiscount?: number | null;
  /** @format int32 */
  reqId: number;
  signName?: string | null;
  /** @format int32 */
  tmId: number;
}

export interface PaymentProtocolGetOrderFormResponse {
  contents: string;
  /** @format int32 */
  reqId: number;
}

export interface PaymentProtocolGetOrderFormUrlRequest {
  /** @format int32 */
  reqId: number;
}

export interface PaymentProtocolGetOrderFormUrlResponse {
  url?: string | null;
}

export interface PaymentProtocolGetPaymentRequest {
  /** @format int32 */
  reqId?: number | null;
  /** @format int32 */
  tmId: number;
}

export interface PaymentProtocolGetPaymentResponse {
  cards: MarqCommonModelCard[];
  ownerDetails: PaymentProtocolOwnerDetails;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  payValidDate: string;
  paymentInfo: PaymentProtocolGetPaymentResponsePaymentInfo;
  /** @format int32 */
  reqId: number;
  trademark?: FolioCommonModelTrademarkDto;
}

export interface PaymentProtocolGetPaymentResponsePayItemInfo {
  classIdList?: FolioCommonModelApClassInfo[] | null;
  invalidTmName?: string | null;
  /** @format double */
  itemDiscountPercent: number;
  otherTypeData?: FolioCoreModelOtherTypeData;
  /** @format int32 */
  payItemId: number;
  payItemName: FolioCommonModelMultiLanguage;
  payItemType: FolioCommonEnumsPayItemTypeEnum;
}

export interface PaymentProtocolGetPaymentResponsePaymentInfo {
  /** @format double */
  overallAddDiscountPercent?: number | null;
  priceInfo: PaymentProtocolGetPaymentResponsePriceInfo[];
}

export interface PaymentProtocolGetPaymentResponsePriceInfo {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  /** @format double */
  countryDiscountPercent?: number | null;
  itemList: PaymentProtocolGetPaymentResponsePayItemInfo[];
}

export interface PaymentProtocolOwnerDetails {
  businessType?: MarqCommonEnumsClientBusinessType;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  email?: string | null;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber?: string | null;
}

export interface PaymentProtocolPlaceAdditionalOrderRequest {
  address: FolioCommonModelAddressWithChina;
  billingDetails: FolioCommonModelBillingDetails;
  hasFailed: boolean;
  ownerDetails: PaymentProtocolOwnerDetails;
  /** @format int32 */
  reqId: number;
}

export interface PaymentProtocolPlaceAdditionalOrderResponse {
  /** @format int32 */
  orderId: number;
}

export interface PaymentProtocolPlaceOrderRequest {
  address: FolioCommonModelAddressWithChina;
  billingDetails: FolioCommonModelBillingDetails;
  ctryPackageList: FolioCoreModelCtryPackageForPayReq[];
  /** @format double */
  overallAddDiscountPercent?: number | null;
  ownerDetails: PaymentProtocolOwnerDetails;
  /** @format int32 */
  reqId: number;
}

export interface PaymentProtocolPlaceOrderResponse {
  /** @format int32 */
  orderId: number;
}

export interface PaymentProtocolRequestPaymentRequest {
  ctryPackageList: FolioCoreModelCtryPackageForPayReq[];
  /** @format int32 */
  tmId: number;
}

export interface PaymentProtocolRequestPaymentResponse {
  /** @format int32 */
  reqId: number;
}

export interface PaymentProtocolTryAgainRequest {
  /** @format int32 */
  reqId?: number | null;
  /** @format int32 */
  tmId: number;
}

export interface PaymentProtocolTryAgainResponse {
  apClassInfo: Record<string, FolioCommonModelApClassInfo[]>;
  cards: MarqCommonModelCard[];
  ownerDetails: PaymentProtocolOwnerDetails;
  paySummaryData: FolioCommonModelTmPricePack;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  payValidDate: string;
  /** @format int32 */
  reqId: number;
  trademark?: FolioCommonModelTrademarkDto;
}

export interface PaymentTyProtocolDeleteAttachmentRequest {
  /** @format int32 */
  attachmentId: number;
  /** @format int32 */
  formId: number;
  formType: FolioCommonEnumsFormTypeEnum;
}

export interface PaymentTyProtocolDeleteQnaSelectionRequest {
  /** @format int32 */
  formId: number;
  isOther: boolean;
  /** @format int32 */
  selectionId?: number | null;
}

export interface PaymentTyProtocolGetAttachmentDownloadUrlRequest {
  url: string;
}

export interface PaymentTyProtocolGetAttachmentDownloadUrlResponse {
  url: string;
}

export interface PaymentTyProtocolGetAttachmentPresignedUrlRequest {
  countryCode: FolioCommonEnumsFolioCountryCodeEnum;
  filename: string;
  /** @format int32 */
  tmId: number;
}

export interface PaymentTyProtocolGetAttachmentPresignedUrlResponse {
  url: string;
}

export interface PaymentTyProtocolGetCtryListRequest {
  /** @format int32 */
  tmId: number;
}

export interface PaymentTyProtocolGetCtryListResponse {
  count: PaymentTyProtocolGetCtryListResponseCount;
  countryList: FolioCommonModelTmFormsStatusFormStatusByCtry[];
}

export interface PaymentTyProtocolGetCtryListResponseCount {
  /** @format int32 */
  completed: number;
  /** @format int32 */
  total: number;
}

export interface PaymentTyProtocolGetDocQnaListRequest {
  countryCode: FolioCommonEnumsFolioCountryCodeEnum;
  /** @format int32 */
  tmId: number;
}

export interface PaymentTyProtocolGetDocQnaListResponse {
  list: FolioCommonModelTmFormDto[];
  partner: string;
}

export interface PaymentTyProtocolGetPaymentStatusRequest {
  /** @format int32 */
  reqId: number;
}

export interface PaymentTyProtocolGetPaymentStatusResponse {
  paymentMethod: MarqCommonEnumsPaymentPaymentMethodEnum;
  status: FolioCommonEnumsPaymentStatusEnum;
}

export interface PaymentTyProtocolSaveAttachmentRequest {
  attachment: FolioCommonModelAttachment;
  /** @format int32 */
  formId: number;
  formType: FolioCommonEnumsFormTypeEnum;
}

export interface PaymentTyProtocolSaveDocPoaMailRequest {
  alreadySubmitted: boolean;
  /** @format int32 */
  formId: number;
}

export interface PaymentTyProtocolSaveDocPoaSignRequest {
  agreementId: string;
  /** @format int32 */
  formId: number;
}

export interface PaymentTyProtocolSaveQnaChosenDateRequest {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  date?: string | null;
  /** @format int32 */
  formId: number;
}

export interface PaymentTyProtocolSaveQnaReplyRequest {
  /** @format int32 */
  formId: number;
  reply: string;
}

export interface PaymentTyProtocolSaveQnaSelectionRequest {
  /** @format int32 */
  formId: number;
  other?: string | null;
  /** @format int32 */
  selectionId?: number | null;
}

export interface WatchProtocolAddWatchTmRequest {
  tmImageUrl?: string | null;
  tmType: MarqCommonEnumsIpTrademarkTypeEnum;
  tmWordName?: string | null;
  watchCountry: FolioCommonEnumsFolioCountryCodeEnum[];
  watchPeriod: FolioCommonEnumsWatchWatchPeriodEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  watchStartDate: string;
}

export interface WatchProtocolGetCountryFilterListResponse {
  countryList: FolioCommonEnumsFolioCountryCodeEnum[];
}

export interface WatchProtocolGetTrademarkDetailsRequest {
  /** @format int32 */
  watchTmCountryStatusDetailsId: number;
}

export interface WatchProtocolGetTrademarkDetailsResponse {
  country?: FolioCommonEnumsFolioCountryCodeEnum;
  ctaText?: string | null;
  status?: FolioCommonEnumsWatchWatchStatusEnum;
  statusDetails?: string | null;
  statusSummary?: string | null;
  tmImageUrl?: string | null;
  tmWordName?: string | null;
  /** @format int32 */
  watchTmCountryId: number;
  /** @format int32 */
  watchTmCountryStatusDetailsId?: number | null;
}

export interface WatchProtocolGetTrademarkGridListRequestWatch {
  search?: string | null;
  sortedBy?: FolioCommonEnumsWatchWatchClientSorted;
  sortedOrder?: MarqCommonEnumsSortedOrderEnum;
  watchCountry?: FolioCommonEnumsFolioCountryCodeEnum[] | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  watchStartDate?: string | null;
  watchStatus?: FolioCommonEnumsWatchWatchStatusEnum[] | null;
  watchTmIdList?: number[] | null;
}

export interface WatchProtocolGetTrademarkGridListResponse {
  list: WatchProtocolGetTrademarkGridListResponseTmGrid[];
}

export interface WatchProtocolGetTrademarkGridListResponseGridTm {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  startDate: string;
  status: FolioCommonEnumsWatchWatchStatusEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updatedDate?: string | null;
  /** @format int32 */
  watchTmCountryId: number;
  /** @format int32 */
  watchTmCountryStatusDetailsId?: number | null;
}

export interface WatchProtocolGetTrademarkGridListResponseTmGrid {
  imageUrl?: string | null;
  tmCountryList: WatchProtocolGetTrademarkGridListResponseGridTm[];
  tmWordName?: string | null;
  /** @format int32 */
  watchTmId: number;
}

export interface WatchProtocolGetTrademarkListRequestWatch {
  search?: string | null;
  sortedBy?: FolioCommonEnumsWatchWatchClientSorted;
  sortedOrder?: MarqCommonEnumsSortedOrderEnum;
  watchCountry?: FolioCommonEnumsFolioCountryCodeEnum[] | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  watchStartDate?: string | null;
  watchStatus?: FolioCommonEnumsWatchWatchStatusEnum[] | null;
  watchTmIdList?: number[] | null;
}

export interface WatchProtocolGetTrademarkListResponse {
  tmList: Record<string, WatchProtocolGetTrademarkListResponseTradeMark[]>;
}

export interface WatchProtocolGetTrademarkListResponseTradeMark {
  tmImageUrl?: string | null;
  tmWordName?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updatedDate?: string | null;
  watchCountry: FolioCommonEnumsFolioCountryCodeEnum;
  watchPeriod: FolioCommonEnumsWatchWatchPeriodEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  watchStartDate?: string | null;
  watchStatus: FolioCommonEnumsWatchWatchStatusEnum;
  watchStatusSummery?: string | null;
  /** @format int32 */
  watchTmCountryId: number;
  /** @format int32 */
  watchTmCountryStatusDetailsId?: number | null;
}

export interface WatchProtocolGetTrademarkNameFilterListResponse {
  tmList: WatchProtocolGetTrademarkNameFilterListResponseTmName[];
}

export interface WatchProtocolGetTrademarkNameFilterListResponseTmName {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate: string;
  imageUrl?: string | null;
  tmWordName?: string | null;
  /** @format int32 */
  watchTmId?: number | null;
}

export interface WatchProtocolGetWatchCountryListResponse {
  countryList: FolioCommonEnumsFolioCountryCodeEnum[];
}

export interface WatchProtocolGetWatchPeriodListResponse {
  periodList: FolioCommonEnumsWatchWatchPeriodEnum[];
}

export interface WatchProtocolRemindMeLaterRequest {
  /** @format int32 */
  watchTmCountryId: number;
}

export interface WatchProtocolRequestActionRequest {
  /** @format int32 */
  watchTmCountryId: number;
}

export interface WatchProtocolWatchTmPresignedUrlRequest {
  tmFileName: string;
}

export interface WatchProtocolWatchTmPresignedUrlResponse {
  tmImageUrl: string;
}

export interface WatchProtocolWatchTmPresignedUrlDownloadRequest {
  url: string;
}

export interface WatchProtocolWatchTmPresignedUrlDownloadResponse {
  url: string;
}

export interface BrandBrandProtocolAddBrandRequest {
  ipTmIdList?: number[] | null;
  name: string;
}

export interface BrandBrandProtocolDeleteBrandRequest {
  /** @format int32 */
  brandId: number;
}

export interface BrandBrandProtocolGetAssetCountRequest {
  /** @format int32 */
  brandId: number;
}

export interface BrandBrandProtocolGetAssetCountResponse {
  /** @format int32 */
  count: number;
}

export interface BrandBrandProtocolGetBrandListResponse {
  brandList: FolioCommonDtoBrandDto[];
}

export interface BrandBrandProtocolGetIpTmByBrandRequest {
  /** @format int32 */
  brandId?: number | null;
}

export interface BrandBrandProtocolGetIpTmByBrandResponse {
  allIpTmList: BrandBrandProtocolGetIpTmByBrandResponseIpTmName[];
  selectedIpTmIdListByBrandId: number[];
}

export interface BrandBrandProtocolGetIpTmByBrandResponseIpTmName {
  /** @format int32 */
  brandId?: number | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate?: string | null;
  /** @format int32 */
  ipTmId: number;
  tmUrl?: string | null;
  tmWord?: string | null;
}

export interface BrandBrandProtocolUpdateBrandRequest {
  /** @format int32 */
  brandId: number;
  ipTmIdList: number[];
  name: string;
}

export interface FolioCommonDtoBrandDto {
  /** @format int32 */
  brandId?: number | null;
  /** @format int32 */
  clientId?: number | null;
  name?: string | null;
}

export interface FolioCommonDtoCustomColumnValueDto {
  /** @format int32 */
  customColumnValueId?: number | null;
  /** @format int32 */
  ipTmColumnTitleId: number;
  /** @format int32 */
  ipTmRegistrationId: number;
  key?: string | null;
  titleEng?: string | null;
  titleKor?: string | null;
  value?: string | null;
}

export interface FolioCommonDtoFolioFile {
  name: string;
  url: string;
}

export interface FolioCommonDtoIpTmIpTmClientFilterDto {
  brandIdList?: number[] | null;
  classIdList?: number[] | null;
  countryList?: FolioCommonEnumsFolioCountryCodeEnum[] | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiryDateFrom?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiryDateTo?: string | null;
  ipTmIdList?: number[] | null;
  isFolioCase?: boolean | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registeredDateFrom?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registeredDateTo?: string | null;
  searchKey?: string | null;
  statusList?: FolioCommonEnumsIpTmStatusEnum[] | null;
}

export interface FolioCommonDtoIpTmIpTmColumnTitleDto {
  /** @format int32 */
  ipTmColumnId: number;
  /** @format int32 */
  ipTmColumnTitleId: number;
  isCustomized: boolean;
  isShown: boolean;
  key: string;
  /** @format int32 */
  order?: number | null;
  titleEng: string;
  titleKor: string;
}

export interface FolioCommonDtoIpTmIpTmRegistrationDto {
  accountOwner?: string | null;
  addStatus?: FolioCommonEnumsAddStatusEnum;
  addressCity?: string | null;
  addressCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  addressStreet?: string | null;
  addressZipCode?: string | null;
  adminNote?: string | null;
  /** @format int32 */
  apTmId?: number | null;
  applicantName?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  applicationDate?: string | null;
  applicationLanguageCode?: FolioCommonEnumsFolioLanguageCodeEnum;
  applicationNumber?: string | null;
  /** @format int32 */
  brandId?: number | null;
  brandName?: string | null;
  classIdList?: number[] | null;
  /** @format int32 */
  clientId?: number | null;
  clientNote?: string | null;
  countryList?: FolioCommonEnumsFolioCountryCodeEnum[] | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expiryDate?: string | null;
  ipId?: string | null;
  /** @format int32 */
  ipTmId?: number | null;
  /** @format int32 */
  ipTmRegistrationId?: number | null;
  ipTypeEnum?: MarqCommonEnumsIpTypeEnum;
  isFolioCase?: boolean | null;
  ownerTypeEnum?: MarqCommonEnumsClientBusinessType;
  registrationCertificateUrlList?: FolioCommonDtoFolioFile[] | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  registrationDate?: string | null;
  registrationNumber?: string | null;
  renewStatus?: FolioCommonEnumsIpTmRenewStatusEnum;
  status?: FolioCommonEnumsIpTmStatusEnum;
  subClassIdList?: number[] | null;
  tmImageUrl?: string | null;
  tmWord?: string | null;
  trademarkOwner?: string | null;
  trademarkType?: MarqCommonEnumsIpTrademarkTypeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updatedDate?: string | null;
  /** @format int32 */
  userId?: number | null;
}

export enum FolioCommonEnumsAddStatusEnum {
  Requested = 'requested',
  Added = 'added',
  Deleted = 'deleted',
}

export enum FolioCommonEnumsApplicationStageEnum {
  FillingApp = 'filling_app',
  AppInReview = 'app_in_review',
  AwaitingTm = 'awaiting_tm',
  TmRegistered = 'tm_registered',
}

export enum FolioCommonEnumsApplicationStatusEnum {
  RequestInProgress = 'request_in_progress',
  EvaluationInProgress = 'evaluation_in_progress',
  WaitingPayment = 'waiting_payment',
  PaymentFailed = 'payment_failed',
  PaymentCanceled = 'payment_canceled',
  FilingPending = 'filing_pending',
  PreparingApp = 'preparing_app',
  AppDrafted = 'app_drafted',
  ApplicationDraftConfirmed = 'application_draft_confirmed',
  PaymentInProgress = 'payment_in_progress',
  ApplicationFiled = 'application_filed',
  PreliminarilyRefused = 'preliminarily_refused',
  DefendingRefusal = 'defending_refusal',
  OppositionPublished = 'opposition_published',
  ApplicationOpposed = 'application_opposed',
  AppealingAgainstRejection = 'appealing_against_rejection',
  RetrievingConflictingMarks = 'retrieving_conflicting_marks',
  ConflictingMarksRetrieved = 'conflicting_marks_retrieved',
  RetrievalFailed = 'retrieval_failed',
  AdditionalPaymentWaiting = 'additional_payment_waiting',
  AdditionalPaymentFailed = 'additional_payment_failed',
  AdditionalPaymentCancelled = 'additional_payment_cancelled',
  AdditionalPaymentSucceeded = 'additional_payment_succeeded',
  ApplicationRejected = 'application_rejected',
  RegistrationGranted = 'registration_granted',
  RegistrationCompleted = 'registration_completed',
}

export enum FolioCommonEnumsApplicationStepEnum {
  Apply = 'apply',
  PrepReport = 'prep_report',
  AddInfo = 'add_info',
  SendReport = 'send_report',
  Contract = 'contract',
  PayWaiting = 'pay_waiting',
  PayExpired = 'pay_expired',
  PayFailed = 'pay_failed',
  PayCanceled = 'pay_canceled',
  FilingPending = 'filing_pending',
  ReqInfoCl = 'req_info_cl',
  ReqInfoAd = 'req_info_ad',
  FilingPrepReport = 'filing_prep_report',
  FilingSendReport = 'filing_send_report',
  FilingResp = 'filing_resp',
  PrepFile = 'prep_file',
  FileDone = 'file_done',
  FileDoneReport = 'file_done_report',
  OaReceive = 'oa_receive',
  OaReceiveReason = 'oa_receive_reason',
  OaReport = 'oa_report',
  OaCaReceive = 'oa_ca_receive',
  OaCaReq = 'oa_ca_req',
  OaCaReport = 'oa_ca_report',
  OaCaNoti = 'oa_ca_noti',
  OppReceive = 'opp_receive',
  OppReport = 'opp_report',
  OppReqInfo = 'opp_req_info',
  OppReqReceive = 'opp_req_receive',
  OppReq = 'opp_req',
  OppReqDone = 'opp_req_done',
  OppReqRedo = 'opp_req_redo',
  OppLose = 'opp_lose',
  OppWin = 'opp_win',
  OppResultReport = 'opp_result_report',
  AppReceive = 'app_receive',
  AppReport = 'app_report',
  AppResultReceive = 'app_result_receive',
  AppLose = 'app_lose',
  AppWin = 'app_win',
  RetrievalInfo = 'retrieval_info',
  RetrievalReq = 'retrieval_req',
  RetrievalDone = 'retrieval_done',
  RetrievalReqReceive = 'retrieval_req_receive',
  RetrievalReqRedo = 'retrieval_req_redo',
  RetrievalReqDone = 'retrieval_req_done',
  RetrievalResultReport = 'retrieval_result_report',
  RetrievalWin = 'retrieval_win',
  RetrievalLose = 'retrieval_lose',
  AdditionalContract = 'additional_contract',
  AdditionalPayWaiting = 'additional_pay_waiting',
  AdditionalPayExpired = 'additional_pay_expired',
  AdditionalPayFailed = 'additional_pay_failed',
  AdditionalPaySucceeded = 'additional_pay_succeeded',
  AdditionalPayCancel = 'additional_pay_cancel',
  RejectReceive = 'reject_receive',
  RejectReport = 'reject_report',
  Waive = 'waive',
  RegReceive = 'reg_receive',
  RegReport = 'reg_report',
  RegDoneReceive = 'reg_done_receive',
  RegDoneReport = 'reg_done_report',
  RegElecReceive = 'reg_elec_receive',
  RegElecReport = 'reg_elec_report',
  CertReceive = 'cert_receive',
  CertSend = 'cert_send',
  CertAnn = 'cert_ann',
  CertAnnDone = 'cert_ann_done',
}

export enum FolioCommonEnumsCtryFormStatusEnum {
  Completed = 'completed',
  ReviewNeeded = 'review_needed',
  InProgress = 'in_progress',
}

export enum FolioCommonEnumsDiscountEnum {
  MultipleCountries = 'multiple_countries',
  SecondApp = 'second_app',
  Package = 'package',
  AddDiscount = 'add_discount',
}

export enum FolioCommonEnumsDocTypeForClientEnum {
  PoaSign = 'poa_sign',
  PoaUpload = 'poa_upload',
  PoaMail = 'poa_mail',
  NonPoa = 'non_poa',
}

export enum FolioCommonEnumsFolioContinentCodeEnum {
  AF = 'AF',
  AN = 'AN',
  AS = 'AS',
  OC = 'OC',
  EU = 'EU',
  NA = 'NA',
  SA = 'SA',
  OT = 'OT',
}

export enum FolioCommonEnumsFolioCountryCodeEnum {
  AF = 'AF',
  AX = 'AX',
  AL = 'AL',
  DZ = 'DZ',
  AS = 'AS',
  AD = 'AD',
  AO = 'AO',
  AI = 'AI',
  AQ = 'AQ',
  AG = 'AG',
  AR = 'AR',
  AM = 'AM',
  AW = 'AW',
  AU = 'AU',
  AT = 'AT',
  AZ = 'AZ',
  BS = 'BS',
  BH = 'BH',
  BD = 'BD',
  BB = 'BB',
  BY = 'BY',
  BE = 'BE',
  BZ = 'BZ',
  BJ = 'BJ',
  BM = 'BM',
  BT = 'BT',
  BO = 'BO',
  BQ = 'BQ',
  BA = 'BA',
  BW = 'BW',
  BV = 'BV',
  BR = 'BR',
  IO = 'IO',
  BN = 'BN',
  BG = 'BG',
  BF = 'BF',
  BI = 'BI',
  KH = 'KH',
  CM = 'CM',
  CA = 'CA',
  CV = 'CV',
  KY = 'KY',
  CF = 'CF',
  TD = 'TD',
  CL = 'CL',
  CN = 'CN',
  CX = 'CX',
  CC = 'CC',
  CO = 'CO',
  KM = 'KM',
  CG = 'CG',
  CD = 'CD',
  CK = 'CK',
  CR = 'CR',
  CI = 'CI',
  HR = 'HR',
  CU = 'CU',
  CW = 'CW',
  CY = 'CY',
  CZ = 'CZ',
  DK = 'DK',
  DJ = 'DJ',
  DM = 'DM',
  DO = 'DO',
  EC = 'EC',
  EG = 'EG',
  SV = 'SV',
  GB = 'GB',
  GQ = 'GQ',
  ER = 'ER',
  EE = 'EE',
  ET = 'ET',
  FK = 'FK',
  FO = 'FO',
  FJ = 'FJ',
  FI = 'FI',
  FR = 'FR',
  GF = 'GF',
  PF = 'PF',
  TF = 'TF',
  GA = 'GA',
  GM = 'GM',
  GE = 'GE',
  DE = 'DE',
  GH = 'GH',
  GI = 'GI',
  GR = 'GR',
  GL = 'GL',
  GD = 'GD',
  GP = 'GP',
  GU = 'GU',
  GT = 'GT',
  GG = 'GG',
  GN = 'GN',
  GW = 'GW',
  GY = 'GY',
  HT = 'HT',
  HM = 'HM',
  VA = 'VA',
  HN = 'HN',
  HK = 'HK',
  HU = 'HU',
  IS = 'IS',
  IN = 'IN',
  ID = 'ID',
  IR = 'IR',
  IQ = 'IQ',
  IE = 'IE',
  IM = 'IM',
  IL = 'IL',
  IT = 'IT',
  JM = 'JM',
  JP = 'JP',
  JE = 'JE',
  JO = 'JO',
  KZ = 'KZ',
  KE = 'KE',
  KI = 'KI',
  KP = 'KP',
  KR = 'KR',
  KW = 'KW',
  KG = 'KG',
  LA = 'LA',
  LV = 'LV',
  LB = 'LB',
  LS = 'LS',
  LR = 'LR',
  LY = 'LY',
  LI = 'LI',
  LT = 'LT',
  LU = 'LU',
  MO = 'MO',
  MK = 'MK',
  MG = 'MG',
  MW = 'MW',
  MV = 'MV',
  MY = 'MY',
  ML = 'ML',
  MT = 'MT',
  MH = 'MH',
  MQ = 'MQ',
  MR = 'MR',
  MU = 'MU',
  YT = 'YT',
  MX = 'MX',
  FM = 'FM',
  MD = 'MD',
  MC = 'MC',
  MN = 'MN',
  ME = 'ME',
  MS = 'MS',
  MA = 'MA',
  MZ = 'MZ',
  MM = 'MM',
  NA = 'NA',
  NR = 'NR',
  NP = 'NP',
  NL = 'NL',
  NC = 'NC',
  NZ = 'NZ',
  NI = 'NI',
  NE = 'NE',
  NG = 'NG',
  NU = 'NU',
  NF = 'NF',
  MP = 'MP',
  NO = 'NO',
  OM = 'OM',
  PK = 'PK',
  PW = 'PW',
  PS = 'PS',
  PA = 'PA',
  PG = 'PG',
  PY = 'PY',
  PE = 'PE',
  PH = 'PH',
  PN = 'PN',
  PL = 'PL',
  PT = 'PT',
  PR = 'PR',
  QA = 'QA',
  RE = 'RE',
  RO = 'RO',
  RU = 'RU',
  RW = 'RW',
  BL = 'BL',
  SH = 'SH',
  KN = 'KN',
  LC = 'LC',
  MF = 'MF',
  PM = 'PM',
  VC = 'VC',
  WS = 'WS',
  SM = 'SM',
  ST = 'ST',
  SA = 'SA',
  SN = 'SN',
  RS = 'RS',
  SC = 'SC',
  SL = 'SL',
  SX = 'SX',
  SG = 'SG',
  SK = 'SK',
  SI = 'SI',
  SB = 'SB',
  SO = 'SO',
  ZA = 'ZA',
  GS = 'GS',
  SS = 'SS',
  ES = 'ES',
  LK = 'LK',
  SD = 'SD',
  SR = 'SR',
  SJ = 'SJ',
  SZ = 'SZ',
  SE = 'SE',
  CH = 'CH',
  SY = 'SY',
  TW = 'TW',
  TJ = 'TJ',
  TZ = 'TZ',
  TL = 'TL',
  TH = 'TH',
  TG = 'TG',
  TK = 'TK',
  TO = 'TO',
  TT = 'TT',
  TN = 'TN',
  TR = 'TR',
  TM = 'TM',
  TC = 'TC',
  TV = 'TV',
  UG = 'UG',
  UA = 'UA',
  AE = 'AE',
  US = 'US',
  UM = 'UM',
  UY = 'UY',
  UZ = 'UZ',
  VU = 'VU',
  VE = 'VE',
  VN = 'VN',
  VG = 'VG',
  VI = 'VI',
  WF = 'WF',
  EH = 'EH',
  YE = 'YE',
  ZM = 'ZM',
  ZW = 'ZW',
  EU = 'EU',
  Value00 = '00',
  Value10 = '10',
}

export enum FolioCommonEnumsFolioLanguageCodeEnum {
  Ab = 'ab',
  Aa = 'aa',
  Af = 'af',
  Ak = 'ak',
  Am = 'am',
  Ar = 'ar',
  Hy = 'hy',
  As = 'as',
  Av = 'av',
  Ae = 'ae',
  Ay = 'ay',
  Az = 'az',
  Bm = 'bm',
  Ba = 'ba',
  Eu = 'eu',
  Be = 'be',
  Bn = 'bn',
  Bi = 'bi',
  Bs = 'bs',
  Br = 'br',
  Bg = 'bg',
  My = 'my',
  Ca = 'ca',
  Ch = 'ch',
  Ce = 'ce',
  Ny = 'ny',
  Zh = 'zh',
  Cu = 'cu',
  Cv = 'cv',
  Kw = 'kw',
  Co = 'co',
  Cr = 'cr',
  Hr = 'hr',
  Cs = 'cs',
  Da = 'da',
  Dv = 'dv',
  Nl = 'nl',
  Dz = 'dz',
  En = 'en',
  Eo = 'eo',
  Et = 'et',
  Ee = 'ee',
  Fo = 'fo',
  Fj = 'fj',
  Fi = 'fi',
  Fr = 'fr',
  Fy = 'fy',
  Ff = 'ff',
  Gd = 'gd',
  Gl = 'gl',
  Lg = 'lg',
  Ka = 'ka',
  De = 'de',
  El = 'el',
  Kl = 'kl',
  Gn = 'gn',
  Gu = 'gu',
  Ht = 'ht',
  Ha = 'ha',
  He = 'he',
  Hz = 'hz',
  Hi = 'hi',
  Ho = 'ho',
  Hu = 'hu',
  Is = 'is',
  Io = 'io',
  Ig = 'ig',
  Id = 'id',
  Ia = 'ia',
  Ie = 'ie',
  Iu = 'iu',
  Ik = 'ik',
  Ga = 'ga',
  It = 'it',
  Ja = 'ja',
  Jv = 'jv',
  Kn = 'kn',
  Kr = 'kr',
  Ks = 'ks',
  Kk = 'kk',
  Km = 'km',
  Ki = 'ki',
  Rw = 'rw',
  Ky = 'ky',
  Kv = 'kv',
  Kg = 'kg',
  Ko = 'ko',
  Kj = 'kj',
  Ku = 'ku',
  Lo = 'lo',
  La = 'la',
  Lv = 'lv',
  Li = 'li',
  Ln = 'ln',
  Lt = 'lt',
  Lu = 'lu',
  Lb = 'lb',
  Mk = 'mk',
  Mg = 'mg',
  Ms = 'ms',
  Ml = 'ml',
  Mt = 'mt',
  Gv = 'gv',
  Mi = 'mi',
  Mr = 'mr',
  Mh = 'mh',
  Mn = 'mn',
  Na = 'na',
  Nv = 'nv',
  Nd = 'nd',
  Nr = 'nr',
  Ng = 'ng',
  Ne = 'ne',
  No = 'no',
  Nb = 'nb',
  Nn = 'nn',
  Ii = 'ii',
  Oc = 'oc',
  Oj = 'oj',
  Or = 'or',
  Om = 'om',
  Os = 'os',
  Pi = 'pi',
  Ps = 'ps',
  Fa = 'fa',
  Pl = 'pl',
  Pt = 'pt',
  Pa = 'pa',
  Qu = 'qu',
  Ro = 'ro',
  Rm = 'rm',
  Rn = 'rn',
  Ru = 'ru',
  Se = 'se',
  Sm = 'sm',
  Sg = 'sg',
  An = 'an',
  Sc = 'sc',
  Sr = 'sr',
  Sn = 'sn',
  Sd = 'sd',
  Si = 'si',
  Sk = 'sk',
  Sl = 'sl',
  So = 'so',
  St = 'st',
  Es = 'es',
  Su = 'su',
  Sw = 'sw',
  Ss = 'ss',
  Sv = 'sv',
  Tl = 'tl',
  Ty = 'ty',
  Tg = 'tg',
  Ta = 'ta',
  Tt = 'tt',
  Te = 'te',
  Th = 'th',
  Bo = 'bo',
  Ti = 'ti',
  To = 'to',
  Ts = 'ts',
  Tn = 'tn',
  Tr = 'tr',
  Tk = 'tk',
  Tw = 'tw',
  Ug = 'ug',
  Uk = 'uk',
  Ur = 'ur',
  Uz = 'uz',
  Ve = 've',
  Vi = 'vi',
  Vo = 'vo',
  Wa = 'wa',
  Cy = 'cy',
  Wo = 'wo',
  Xh = 'xh',
  Yi = 'yi',
  Yo = 'yo',
  Za = 'za',
  Zu = 'zu',
}

export enum FolioCommonEnumsFormStatusEnum {
  InProgress = 'in_progress',
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

export enum FolioCommonEnumsFormTypeEnum {
  Doc = 'doc',
  Qna = 'qna',
}

export enum FolioCommonEnumsIpNotificationTypeEnum {
  IpWillExpire = 'ip_will_expire',
  IpRegistered = 'ip_registered',
  IpInOfficeAction = 'ip_in_office_action',
  IpHasExpiredCanceled = 'ip_has_expired_canceled',
  WatchRiskDetected = 'watch_risk_detected',
}

export enum FolioCommonEnumsIpReminderPeriodEnum {
  NextWeek = 'next_week',
  NextMonth = 'next_month',
  ThreeMonths = 'three_months',
  Never = 'never',
}

export enum FolioCommonEnumsIpTmClientOrderEnum {
  RegisteredDateAsc = 'registered_date_asc',
  RegisteredDateDesc = 'registered_date_desc',
  ExpiryDateAsc = 'expiry_date_asc',
  ExpiryDateDesc = 'expiry_date_desc',
  MarkAsc = 'mark_asc',
  MarkDesc = 'mark_desc',
  UpdatedDateAsc = 'updated_date_asc',
  UpdatedDateDesc = 'updated_date_desc',
}

export enum FolioCommonEnumsIpTmRenewStatusEnum {
  Renewable = 'renewable',
  Requested = 'requested',
}

export enum FolioCommonEnumsIpTmStatusEnum {
  Filling = 'filling',
  Filed = 'filed',
  InOfficeAction = 'in_office_action',
  Ended = 'ended',
  Expired = 'expired',
  Deleted = 'deleted',
  Registered = 'registered',
  NA = 'n/a',
}

export enum FolioCommonEnumsLanguageEnum {
  En = 'en',
  Kr = 'kr',
}

export enum FolioCommonEnumsMyAppSorted {
  SubmittedDate = 'submitted_date',
  UpdatedDate = 'updated_date',
}

export interface FolioCommonEnumsPageNationDto {
  /** @format int32 */
  pageNum: number;
  /** @format int32 */
  pageSize: number;
}

export enum FolioCommonEnumsPayItemTypeEnum {
  TmApp = 'tm_app',
  TmRegist = 'tm_regist',
  TmOa = 'tm_oa',
  AppealRefusal = 'appeal_refusal',
  OppConflict = 'opp_conflict',
  CancelConflict = 'cancel_conflict',
  InvalidConflict = 'invalid_conflict',
  DrApp = 'dr_app',
  DrRegist = 'dr_regist',
  DrOa = 'dr_oa',
  GtFilling = 'gt_filling',
  GtRecovery = 'gt_recovery',
  Other = 'other',
}

export enum FolioCommonEnumsPaymentKindEnum {
  Application = 'application',
  Additional = 'additional',
}

export enum FolioCommonEnumsPaymentStatusEnum {
  Requested = 'requested',
  Success = 'success',
  Failed = 'failed',
  Overdue = 'overdue',
  Incomplete = 'incomplete',
  Canceled = 'canceled',
}

export enum FolioCommonEnumsPreConflictStatusEnum {
  OvercomingMarks = 'overcoming_marks',
  OvercameMarks = 'overcame_marks',
  FailedMarks = 'failed_marks',
}

export enum FolioCommonEnumsPreConflictStepEnum {
  OppInfo = 'opp_info',
  OppReq = 'opp_req',
  OppDone = 'opp_done',
  OppResp = 'opp_resp',
  OppRedo = 'opp_redo',
  OppRedoDone = 'opp_redo_done',
  ResultReceive = 'result_receive',
  OvercameMarks = 'overcame_marks',
  FailedMarks = 'failed_marks',
}

export enum FolioCommonEnumsQnaTypeEnum {
  SSelection = 's_selection',
  MSelection = 'm_selection',
  Reply = 'reply',
  AttachFiles = 'attach_files',
  Date = 'date',
}

export enum FolioCommonEnumsTmDocScopeEnum {
  Application = 'application',
  Common = 'common',
}

export enum FolioCommonEnumsQnaApQnaTypeEnum {
  SSelection = 's_selection',
  MSelection = 'm_selection',
  Free = 'free',
}

export enum FolioCommonEnumsWatchWatchClientSorted {
  UpdatedDate = 'updated_date',
  TrademarkName = 'trademark_name',
  WatchStartDate = 'watch_start_date',
  Status = 'status',
  Urgency = 'urgency',
}

export enum FolioCommonEnumsWatchWatchPeriodEnum {
  OneMonths = 'one_months',
  ThreeMonths = 'three_months',
  SixMonths = 'six_months',
  OneYear = 'one_year',
  ThreeYear = 'three_year',
}

export enum FolioCommonEnumsWatchWatchStatusEnum {
  RiskDetected = 'risk_detected',
  ActionTaken = 'action_taken',
  Safe = 'safe',
  WatchRequested = 'watch_requested',
  ActionRequested = 'action_requested',
  Pending = 'pending',
}

export interface FolioCommonModelAddressForeign {
  city?: string | null;
  streetAddress?: string | null;
  translationReq: boolean;
  zipcode?: string | null;
}

export interface FolioCommonModelAddressWithChina {
  chineseAddress?: FolioCommonModelAddressForeign;
  city: string;
  country: FolioCommonEnumsFolioCountryCodeEnum;
  streetAddress: string;
  zipcode: string;
}

export interface FolioCommonModelAddressWithCountry {
  city: string;
  country: FolioCommonEnumsFolioCountryCodeEnum;
  streetAddress: string;
  zipcode: string;
}

export interface FolioCommonModelApClassInfo {
  /** @format int32 */
  classId: number;
  otherNoteList?: FolioCommonModelApClassInfoOtherNote[] | null;
  subClassIdList: number[];
}

export interface FolioCommonModelApClassInfoOtherNote {
  en: string;
  ko: string;
}

export interface FolioCommonModelAttachment {
  name: string;
  url: string;
}

export interface FolioCommonModelBillingDetails {
  address: FolioCommonModelAddressWithCountry;
  businessType?: MarqCommonEnumsClientBusinessType;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber?: string | null;
}

export interface FolioCommonModelClientAttachment {
  /** @format int32 */
  id: number;
  name: string;
  url: string;
}

export interface FolioCommonModelCommentForClient {
  commentString: string;
  lastSubmissionUrl?: string | null;
}

export interface FolioCommonModelCountryPriceDto {
  country: FolioCommonModelCountryPriceDtoCountry;
  price: FolioCommonModelCountryPriceDtoPrice;
}

export interface FolioCommonModelCountryPriceDtoCountry {
  code: FolioCommonEnumsFolioCountryCodeEnum;
  continent: FolioCommonEnumsFolioContinentCodeEnum;
  name?: FolioCommonModelMultiLanguage;
}

export interface FolioCommonModelCountryPriceDtoPrice {
  /** @format double */
  addPrice: number;
  /** @format double */
  firstPrice: number;
  /** @format double */
  govtAdd: number;
  /** @format double */
  govtFirst: number;
}

export interface FolioCommonModelDiscountDataDiscount {
  name: FolioCommonEnumsDiscountEnum;
  /** @format double */
  percent: number;
}

export interface FolioCommonModelDocuSignInfo {
  accountId: string;
  clickwrapId: string;
  clientUserId: string;
  documentData: FolioCommonModelDocumentData;
  environment: string;
}

export type FolioCommonModelDocumentData = object;

export interface FolioCommonModelGuide {
  attachments: FolioCommonModelAttachment[];
  guideString: FolioCommonModelMultiLanguage;
}

export interface FolioCommonModelMultiLanguage {
  en?: string | null;
  ko?: string | null;
}

export interface FolioCommonModelPrevSelection {
  isOther: boolean;
  /** @format int32 */
  prevQnaId: number;
  /** @format int32 */
  prevSelectionId?: number | null;
}

export interface FolioCommonModelRelatedApDto {
  relatedApIdList: number[];
  /** @format int32 */
  relatedListId?: number | null;
}

export interface FolioCommonModelTmFormDto {
  comment?: FolioCommonModelCommentForClient;
  formFields: FolioCommonModelTmFormDtoTmFormFields;
  /** @format int32 */
  formId: number;
  formType: FolioCommonEnumsFormTypeEnum;
  guide: FolioCommonModelGuide;
  name: FolioCommonModelMultiLanguage;
  status: FolioCommonEnumsFormStatusEnum;
  tmDocScope: FolioCommonEnumsTmDocScopeEnum;
}

export type FolioCommonModelTmFormDtoTmDocFields =
  | FolioCommonModelTmFormDtoTmDocNonPoaFields
  | FolioCommonModelTmFormDtoTmDocPoaMailFields
  | FolioCommonModelTmFormDtoTmDocPoaSignFields
  | FolioCommonModelTmFormDtoTmDocPoaUploadFields;

export interface FolioCommonModelTmFormDtoTmDocNonPoaFields {
  clientAttachments: FolioCommonModelClientAttachment[];
  docType: FolioCommonEnumsDocTypeForClientEnum;
}

export interface FolioCommonModelTmFormDtoTmDocPoaMailFields {
  alreadySubmitted: boolean;
  docType: FolioCommonEnumsDocTypeForClientEnum;
}

export interface FolioCommonModelTmFormDtoTmDocPoaSignFields {
  docType: FolioCommonEnumsDocTypeForClientEnum;
  docuSignInfo?: FolioCommonModelDocuSignInfo;
}

export interface FolioCommonModelTmFormDtoTmDocPoaUploadFields {
  clientAttachments: FolioCommonModelClientAttachment[];
  docType: FolioCommonEnumsDocTypeForClientEnum;
}

export type FolioCommonModelTmFormDtoTmFormFields =
  | FolioCommonModelTmFormDtoTmDocFields
  | FolioCommonModelTmFormDtoTmQnaFields;

export interface FolioCommonModelTmFormDtoTmQnaDateFields {
  prevSelection?: FolioCommonModelPrevSelection;
  qnaType: FolioCommonEnumsQnaTypeEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  selectedDate?: string | null;
}

export type FolioCommonModelTmFormDtoTmQnaFields =
  | FolioCommonModelTmFormDtoTmQnaDateFields
  | FolioCommonModelTmFormDtoTmQnaReplyFields
  | FolioCommonModelTmFormDtoTmQnaSelectionFields
  | FolioCommonModelTmFormDtoTmQnaUploadFields;

export interface FolioCommonModelTmFormDtoTmQnaReplyFields {
  prevSelection?: FolioCommonModelPrevSelection;
  qnaType: FolioCommonEnumsQnaTypeEnum;
  reply?: string | null;
}

export interface FolioCommonModelTmFormDtoTmQnaSelectionFields {
  prevSelection?: FolioCommonModelPrevSelection;
  qnaType: FolioCommonEnumsQnaTypeEnum;
  selections: FolioCommonModelTmQnaSelections;
}

export interface FolioCommonModelTmFormDtoTmQnaUploadFields {
  clientAttachments: FolioCommonModelClientAttachment[];
  prevSelection?: FolioCommonModelPrevSelection;
  qnaType: FolioCommonEnumsQnaTypeEnum;
}

export interface FolioCommonModelTmFormsStatusFormStatusByCtry {
  countryCode: FolioCommonEnumsFolioCountryCodeEnum;
  status: FolioCommonEnumsCtryFormStatusEnum;
}

export interface FolioCommonModelTmPricePack {
  adminNote?: string | null;
  ctryPriceList: FolioCommonModelTmPricePackCtryPricePack[];
  /** @format double */
  multipleCountryDiscountPercent: number;
  /** @format double */
  multipleCountryDiscountPrice: number;
  /** @format double */
  overallAddDiscountPercent: number;
  /** @format double */
  overallAddDiscountPrice: number;
  /** @format double */
  secondAppDiscountPercent: number;
  /** @format double */
  secondAppDiscountPrice: number;
  /** @format double */
  totalGovFee: number;
  /** @format double */
  totalPrice: number;
  /** @format double */
  totalProtectionPlan: number;
  /** @format double */
  totalServiceFee: number;
}

export interface FolioCommonModelTmPricePackCtryPricePack {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  /** @format double */
  ctryTotalPrice: number;
  /** @format double */
  discountPercent: number;
  /** @format double */
  discountPrice: number;
  /** @format double */
  discountedServiceFee: number;
  /** @format double */
  insurancePrice: number;
  itemList?: FolioCommonModelTmPricePackPayItem[] | null;
  /** @format double */
  noDiscountedTotalPrice: number;
  /** @format double */
  packageDiscountPercent: number;
  /** @format double */
  packageDiscountPrice: number;
  /** @format double */
  serviceFee: number;
}

export interface FolioCommonModelTmPricePackItemFee {
  /** @format double */
  govFee: number;
  /** @format double */
  protectionPlan: number;
  /** @format double */
  serviceFee: number;
}

export interface FolioCommonModelTmPricePackPayItem {
  additionalClass?: FolioCommonModelTmPricePackItemFee;
  classIdList?: FolioCommonModelApClassInfo[] | null;
  /** @format int32 */
  classSize: number;
  /** @format double */
  discountFee: number;
  /** @format double */
  discountPercent: number;
  eachAdditionalClass?: FolioCommonModelTmPricePackItemFee;
  firstClass: FolioCommonModelTmPricePackItemFee;
  invalidTmName?: string | null;
  /** @format int32 */
  payItemId?: number | null;
  payItemName: FolioCommonModelMultiLanguage;
  /** @format double */
  payItemTotalGovFee: number;
  /** @format double */
  payItemTotalPrice: number;
  /** @format double */
  payItemTotalProtectionPlan: number;
  /** @format double */
  payItemTotalServiceFee: number;
  payItemType: FolioCommonEnumsPayItemTypeEnum;
}

export interface FolioCommonModelTmQnaSelections {
  other?: string | null;
  selectionList: FolioCommonModelTmQnaSelectionsSelection[];
  useOther: boolean;
}

export interface FolioCommonModelTmQnaSelectionsSelection {
  selected: boolean;
  /** @format int32 */
  selectionId?: number | null;
  selectionStrings: FolioCommonModelMultiLanguage;
}

export interface FolioCommonModelTrademarkDto {
  imageName?: string | null;
  imageUrl?: string | null;
  relatedAp?: FolioCommonModelRelatedApDto;
  stylized?: boolean | null;
  tagList?: string[] | null;
  trademarkType: MarqCommonEnumsIpTrademarkTypeEnum;
  word?: string | null;
}

export interface FolioCoreModelCtryPackageForPayReq {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  /** @format double */
  discountPercent: number;
  /** @format double */
  packageDiscountPercent: number;
  payItemList?: FolioCoreModelCtryPackageForPayReqPayReqPayItem[] | null;
}

export interface FolioCoreModelCtryPackageForPayReqPayReqPayItem {
  classIdList: FolioCommonModelApClassInfo[];
  /** @format double */
  discount: number;
  invalidTmName: string;
  otherTypeData?: FolioCoreModelOtherTypeData;
  payItemType: FolioCommonEnumsPayItemTypeEnum;
}

export interface FolioCoreModelCtrySubClassIdInfo {
  countryCode?: FolioCommonEnumsFolioCountryCodeEnum;
  subClassIdList: number[];
}

export interface FolioCoreModelFilenameUrl {
  filename: string;
  url: string;
}

export interface FolioCoreModelOtherTypeData {
  name: FolioCommonModelMultiLanguage;
  pricePackage: FolioCoreModelOtherTypeDataCustomPricePackage;
}

export interface FolioCoreModelOtherTypeDataCustomPricePackage {
  /** @format double */
  govtAddPrice: number;
  /** @format double */
  govtPrice: number;
  /** @format double */
  insuranceAddPrice: number;
  /** @format double */
  insurancePrice: number;
  /** @format double */
  serviceAddPrice: number;
  /** @format double */
  servicePrice: number;
}

export interface FolioCoreModelAdminNoteAdminNote {
  /** @format int32 */
  adminNoteId: number;
  contents?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate: string;
  fileList?: FolioDataModelNoteFile[] | null;
  isShared: boolean;
  /** @format int32 */
  relatedQnaId?: number | null;
}

export interface FolioCoreModelApApGroupClientHistoryResponse {
  classList: number[];
  country: FolioCommonEnumsFolioCountryCodeEnum;
  list: FolioCoreModelApApGroupClientHistoryResponseStageItem[];
  /**
   * @format date
   * @example "2023-03-01"
   */
  toBeCompletedDate?: string | null;
}

export interface FolioCoreModelApApGroupClientHistoryResponseAdditionalPayment {
  invoiceUrl?: string | null;
  ongoing: boolean;
  orderFormUrl?: string | null;
  /** @format int32 */
  paymentId: number;
  paymentList: FolioCoreModelApApGroupClientHistoryResponsePaymentItem[];
  paymentStatus: FolioCommonEnumsPaymentStatusEnum;
}

export interface FolioCoreModelApApGroupClientHistoryResponseAppPayment {
  invoiceUrl?: string | null;
  orderFormUrl?: string | null;
  /** @format int32 */
  paymentId?: number | null;
  paymentList?: FolioCoreModelApApGroupClientHistoryResponsePaymentItem[] | null;
  paymentStatus?: FolioCommonEnumsPaymentStatusEnum;
}

export interface FolioCoreModelApApGroupClientHistoryResponsePaymentItem {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate: string;
  /** @format int32 */
  paymentId: number;
  paymentStatus: FolioCommonEnumsPaymentStatusEnum;
}

export interface FolioCoreModelApApGroupClientHistoryResponseStageItem {
  list: FolioCoreModelApApGroupClientHistoryResponseStatusItem[];
  stage: FolioCommonEnumsApplicationStageEnum;
}

export interface FolioCoreModelApApGroupClientHistoryResponseStatusItem {
  additionalPaymentList?: FolioCoreModelApApGroupClientHistoryResponseAdditionalPayment[] | null;
  adminNote?: FolioCoreModelAdminNoteAdminNote;
  appPaymentList?: FolioCoreModelApApGroupClientHistoryResponseAppPayment[] | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate: string;
  /** @format int32 */
  historyId: number;
  ongoing: boolean;
  status: FolioCommonEnumsApplicationStatusEnum;
  step: FolioCommonEnumsApplicationStepEnum;
}

export interface FolioCoreModelApClassDto {
  /** @format int32 */
  id: number;
  identifier?: FolioCommonModelMultiLanguage;
  subClassList?: FolioCoreModelApClassDtoSubClass[] | null;
  title?: FolioCommonModelMultiLanguage;
}

export interface FolioCoreModelApClassDtoSubClass {
  /** @format int32 */
  id: number;
  isGlobal: boolean;
  isOthers: boolean;
  selectable: boolean;
  title?: FolioCommonModelMultiLanguage;
}

export interface FolioCoreModelApStatusSectionDto {
  appInReview: FolioCoreModelApStatusSectionDtoCountryStatus[];
  awaitingTm: FolioCoreModelApStatusSectionDtoCountryStatus[];
  fillingApp: FolioCoreModelApStatusSectionDtoCountryStatus[];
  nextStatus?: FolioCommonEnumsApplicationStatusEnum;
  stage: FolioCommonEnumsApplicationStageEnum;
  status?: FolioCommonEnumsApplicationStatusEnum;
  tmRegistered: FolioCoreModelApStatusSectionDtoCountryStatus[];
}

export interface FolioCoreModelApStatusSectionDtoCountryStatus {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  formCount?: FolioCoreModelApStatusSectionDtoCountryStatusFormCount;
  nextStatus: FolioCommonEnumsApplicationStatusEnum;
  preConflictStatus?: FolioCommonEnumsPreConflictStatusEnum;
  status: FolioCommonEnumsApplicationStatusEnum;
}

export interface FolioCoreModelApStatusSectionDtoCountryStatusFormCount {
  /** @format int32 */
  completedCount: number;
  /** @format int32 */
  totalCount: number;
}

export interface FolioCoreModelApTmReferenceDto {
  fileList: FolioCoreModelApTmReferenceDtoRefFile[];
  linkList: string[];
}

export interface FolioCoreModelApTmReferenceDtoRefFile {
  filename: string;
  /** @format int32 */
  id?: number | null;
  url: string;
}

export interface FolioCoreModelApTmUsageDto {
  /**
   * @format date
   * @example "2023-03-01"
   */
  otherFirstDate?: string | null;
  /**
   * @format date
   * @example "2023-03-01"
   */
  usFirstDate?: string | null;
  usage: boolean;
}

export interface FolioCoreModelQnaQnaDto {
  adminName?: string | null;
  answer?: FolioCoreModelQnaQnaDtoAnswer;
  completed: boolean;
  countryList: FolioCommonEnumsFolioCountryCodeEnum[];
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate: string;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  deadline?: string | null;
  /** @format int32 */
  maxFileNumber?: number | null;
  /** @format int32 */
  qnaId: number;
  question: FolioCoreModelQnaQnaDtoQuestion;
  requestOwner?: string | null;
  selectionOption?: FolioCoreModelQnaQnaDtoSelectionOption;
  type: FolioCommonEnumsQnaApQnaTypeEnum;
}

export type FolioCoreModelQnaQnaDtoAnswer = FolioCoreModelQnaQnaDtoFreeAnswer | FolioCoreModelQnaQnaDtoSelectionAnswer;

export interface FolioCoreModelQnaQnaDtoFreeAnswer {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate: string;
  fileList: FolioCoreModelFilenameUrl[];
  from: string;
  imageList: FolioCoreModelFilenameUrl[];
  text: string;
}

export interface FolioCoreModelQnaQnaDtoQuestion {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate: string;
  fileList: FolioCoreModelFilenameUrl[];
  from?: string | null;
  imageList: FolioCoreModelFilenameUrl[];
  text: string;
}

export interface FolioCoreModelQnaQnaDtoSelection {
  /** @format int32 */
  id: number;
  selected: boolean;
  text: string;
}

export interface FolioCoreModelQnaQnaDtoSelectionAnswer {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate: string;
  from: string;
  list: FolioCoreModelQnaQnaDtoSelection[];
  other?: string | null;
}

export interface FolioCoreModelQnaQnaDtoSelectionOption {
  selectionList: FolioCoreModelQnaQnaDtoSelection[];
  useOther: boolean;
}

export interface FolioDataModelNoteFile {
  name: string;
  url: string;
}

export interface IptrademarkIpStatusProtocolGetClassIdListResponse {
  classIdList?: number[] | null;
}

export interface IptrademarkIpStatusProtocolGetNotificationListRequest {
  brandIdList?: number[] | null;
  classIdList?: number[] | null;
  countryList?: FolioCommonEnumsFolioCountryCodeEnum[] | null;
  ipTmRegistrationIdList?: number[] | null;
  ipTypeList?: MarqCommonEnumsIpTypeEnum[] | null;
  isWatching?: boolean | null;
  notificationType?: FolioCommonEnumsIpNotificationTypeEnum;
  tmStatusList?: FolioCommonEnumsIpTmStatusEnum[] | null;
  watchStatusList?: FolioCommonEnumsWatchWatchStatusEnum[] | null;
  watchTmCountryIdList?: number[] | null;
  watchTmIdList?: number[] | null;
}

export interface IptrademarkIpStatusProtocolGetNotificationListResponse {
  ipNotificationList: IptrademarkIpStatusProtocolGetNotificationListResponseIpNotification[];
}

export interface IptrademarkIpStatusProtocolGetNotificationListResponseIpNotification {
  /** @format int32 */
  apTmId?: number | null;
  classIdList?: number[] | null;
  contentsEng: string;
  contentsKor: string;
  countryList: FolioCommonEnumsFolioCountryCodeEnum[];
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate: string;
  /** @format int32 */
  ipNotificationId: number;
  ipNotificationType: FolioCommonEnumsIpNotificationTypeEnum;
  /** @format int32 */
  ipTmRegistrationId?: number | null;
  tmImageUrl?: string | null;
  tmWord?: string | null;
  /** @format int32 */
  watchTmCountryId?: number | null;
  /** @format int32 */
  watchTmCountryStatusDetailsId?: number | null;
}

export interface IptrademarkIpStatusProtocolGetStatusByCountryRequest {
  brandIdList?: number[] | null;
  classIdList?: number[] | null;
  ipTmId?: number[] | null;
  ipTypeList?: MarqCommonEnumsIpTypeEnum[] | null;
  isWatching?: boolean | null;
  tmStatusList?: FolioCommonEnumsIpTmStatusEnum[] | null;
  watchStatusList?: FolioCommonEnumsWatchWatchStatusEnum[] | null;
  watchTmCountryIdList?: number[] | null;
  watchTmIdList?: number[] | null;
}

export interface IptrademarkIpStatusProtocolGetStatusByCountryResponse {
  countryList: IptrademarkIpStatusProtocolGetStatusByCountryResponseStatusDetails[];
}

export interface IptrademarkIpStatusProtocolGetStatusByCountryResponseStatusDetails {
  continent: FolioCommonEnumsFolioContinentCodeEnum;
  country: FolioCommonEnumsFolioCountryCodeEnum;
  trademarkList?: IptrademarkIpStatusProtocolGetStatusByCountryResponseTmDetails[] | null;
  unProtectedIpList?: IptrademarkIpStatusProtocolGetStatusByCountryResponseTmDetails[] | null;
  watchList?: IptrademarkIpStatusProtocolGetStatusByCountryResponseWatchDetails[] | null;
}

export interface IptrademarkIpStatusProtocolGetStatusByCountryResponseTmDetails {
  classIdList?: number[] | null;
  country: FolioCommonEnumsFolioCountryCodeEnum;
  /** @format int32 */
  ipTmId?: number | null;
  /** @format int32 */
  ipTmRegistrationId?: number | null;
  status?: FolioCommonEnumsIpTmStatusEnum;
  tmImageUrl?: string | null;
  tmWord?: string | null;
}

export interface IptrademarkIpStatusProtocolGetStatusByCountryResponseWatchDetails {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  status?: FolioCommonEnumsWatchWatchStatusEnum;
  tmImageUrl?: string | null;
  tmWord?: string | null;
  /** @format int32 */
  watchTmCountryId?: number | null;
  /** @format int32 */
  watchTmCountryStatusDetailsId?: number | null;
}

export interface IptrademarkIpStatusProtocolRequestRenewalRequest {
  /** @format int32 */
  ipNotificationId: number;
}

export interface IptrademarkIpStatusProtocolSetIgnoreRequest {
  /** @format int32 */
  ipNotificationId: number;
  period: FolioCommonEnumsIpReminderPeriodEnum;
}

export interface IptrademarkIpTrademarkProtocolAddCustomColumnTitleRequest {
  title: string;
}

export interface IptrademarkIpTrademarkProtocolAddCustomColumnTitleResponse {
  /** @format int32 */
  ipTmColumnTitleId: number;
}

export interface IptrademarkIpTrademarkProtocolAddCustomColumnValueRequest {
  /** @format int32 */
  ipTmColumnId: number;
  /** @format int32 */
  ipTmColumnTitleId: number;
  /** @format int32 */
  ipTmRegistrationId: number;
  value: string;
}

export interface IptrademarkIpTrademarkProtocolAddIpTmWithNumberRequest {
  applicationNumber?: string | null;
  registrationNumber?: string | null;
}

export interface IptrademarkIpTrademarkProtocolAddIpTrademarkWithRegiCertificateRequest {
  urlList: FolioCommonDtoFolioFile[];
}

export interface IptrademarkIpTrademarkProtocolAddTmWithFileRequest {
  url: string;
}

export interface IptrademarkIpTrademarkProtocolAddTmWithFileResponse {
  errorMessageList?: string[] | null;
}

export interface IptrademarkIpTrademarkProtocolDeleteColumnTitleRequest {
  /** @format int32 */
  ipTmColumnTitleId: number;
}

export interface IptrademarkIpTrademarkProtocolDeleteIpTmNoticeResponse {
  hasNewIpTmRegistration: boolean;
}

export interface IptrademarkIpTrademarkProtocolDeleteIpTrademarkRequest {
  /** @format int32 */
  ipTmRegistrationId: number;
}

export interface IptrademarkIpTrademarkProtocolGetColumnTitleListResponse {
  columnList?: FolioCommonDtoIpTmIpTmColumnTitleDto[] | null;
  /** @format int32 */
  ipTmColumnId?: number | null;
}

export interface IptrademarkIpTrademarkProtocolGetDownloadUrlRequest {
  url: string;
}

export interface IptrademarkIpTrademarkProtocolGetDownloadUrlResponse {
  url: string;
}

export interface IptrademarkIpTrademarkProtocolGetIpTmResponse {
  ipTmNameList: IptrademarkIpTrademarkProtocolGetIpTmResponseIpTmName[];
}

export interface IptrademarkIpTrademarkProtocolGetIpTmResponseIpTmName {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate?: string | null;
  /** @format int32 */
  ipTmId: number;
  tmUrl?: string | null;
  tmWord?: string | null;
}

export interface IptrademarkIpTrademarkProtocolGetIpTmNoticeResponse {
  hasNewIpTmRegistration: boolean;
}

export interface IptrademarkIpTrademarkProtocolGetIpTmRegistrationListRequest {
  filter: FolioCommonDtoIpTmIpTmClientFilterDto;
  language?: FolioCommonEnumsLanguageEnum;
  order: FolioCommonEnumsIpTmClientOrderEnum;
  page: FolioCommonEnumsPageNationDto;
}

export interface IptrademarkIpTrademarkProtocolGetIpTmRegistrationListResponse {
  columnList?: FolioCommonDtoIpTmIpTmColumnTitleDto[] | null;
  data?: IptrademarkIpTrademarkProtocolGetIpTmRegistrationListResponseIpTmResponse[] | null;
  /** @format int32 */
  totalSize: number;
}

export interface IptrademarkIpTrademarkProtocolGetIpTmRegistrationListResponseIpTm {
  /** @format int32 */
  ipTmId?: number | null;
  tmUrl?: string | null;
  tmWord?: string | null;
}

export interface IptrademarkIpTrademarkProtocolGetIpTmRegistrationListResponseIpTmResponse {
  customData?: FolioCommonDtoCustomColumnValueDto[] | null;
  ipTm?: IptrademarkIpTrademarkProtocolGetIpTmRegistrationListResponseIpTm;
  originData?: FolioCommonDtoIpTmIpTmRegistrationDto;
  renew?: IptrademarkIpTrademarkProtocolGetIpTmRegistrationListResponseRenew;
}

export interface IptrademarkIpTrademarkProtocolGetIpTmRegistrationListResponseRenew {
  /** @format int32 */
  ipNotificationId?: number | null;
  renewStatus?: FolioCommonEnumsIpTmRenewStatusEnum;
}

export interface IptrademarkIpTrademarkProtocolGetIpTmSampleFileUrlResponse {
  url: string;
}

export interface IptrademarkIpTrademarkProtocolGetIpTrademarkDetailsRequest {
  /** @format int32 */
  ipTmRegistrationId: number;
}

export interface IptrademarkIpTrademarkProtocolGetIpTrademarkDetailsResponse {
  customData?: FolioCommonDtoCustomColumnValueDto[] | null;
  ipTmRegistrationId: FolioCommonDtoIpTmIpTmRegistrationDto;
}

export interface IptrademarkIpTrademarkProtocolGetLanguageCodeListResponse {
  languageList: IptrademarkIpTrademarkProtocolGetLanguageCodeListResponseLanguageCode[];
}

export interface IptrademarkIpTrademarkProtocolGetLanguageCodeListResponseLanguageCode {
  code: string;
  name: string;
}

export interface IptrademarkIpTrademarkProtocolGetRegiCertifiPresignedUrlRequest {
  filename: string;
}

export interface IptrademarkIpTrademarkProtocolGetRegiCertifiPresignedUrlResponse {
  url: string;
}

export interface IptrademarkIpTrademarkProtocolUpdateColumnOrderRequest {
  columnList: IptrademarkIpTrademarkProtocolUpdateColumnOrderRequestIpTmColumn[];
}

export interface IptrademarkIpTrademarkProtocolUpdateColumnOrderRequestIpTmColumn {
  /** @format int32 */
  ipTmColumnTitleId: number;
  isShown: boolean;
  /** @format int32 */
  order: number;
}

export interface IptrademarkIpTrademarkProtocolUpdateColumnTitleRequest {
  /** @format int32 */
  ipTmColumnTitleId: number;
  title: string;
}

export interface IptrademarkIpTrademarkProtocolUpdateIpTmAdditionalInfoRequest {
  /** @format int32 */
  brandId?: number | null;
  customColumn?: IptrademarkIpTrademarkProtocolUpdateIpTmAdditionalInfoRequestColumnValue[] | null;
  /** @format int32 */
  ipTmRegistrationId: number;
  note?: string | null;
}

export interface IptrademarkIpTrademarkProtocolUpdateIpTmAdditionalInfoRequestColumnValue {
  /** @format int32 */
  customColumnValueId?: number | null;
  /** @format int32 */
  ipTmColumnTitleId: number;
  value?: string | null;
}

export interface IptrademarkIpTrademarkProtocolUpdateIpTrademarkDetailsRequest {
  customData?: FolioCommonDtoCustomColumnValueDto[] | null;
  ipTmRegistration: FolioCommonDtoIpTmIpTmRegistrationDto;
}

export enum MarqCommonEnumsIpTypeEnum {
  Trademark = 'trademark',
  Copyright = 'copyright',
  Design = 'design',
  NotFound = 'not_found',
}

export enum MarqCommonEnumsLanguageEnum {
  Ae = 'ae',
  Ar = 'ar',
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  Id = 'id',
  In = 'in',
  It = 'it',
  Ja = 'ja',
  Ko = 'ko',
  Nl = 'nl',
  Pt = 'pt',
  Th = 'th',
  Tr = 'tr',
  Vi = 'vi',
  Zh = 'zh',
  Ru = 'ru',
  Tw = 'tw',
  Uk = 'uk',
  Sk = 'sk',
  Hu = 'hu',
  Cs = 'cs',
  Mn = 'mn',
  Ms = 'ms',
  Pl = 'pl',
  El = 'el',
  Ro = 'ro',
  Bs = 'bs',
  Bg = 'bg',
  Ur = 'ur',
  Kk = 'kk',
  Uz = 'uz',
}

export enum MarqCommonEnumsSortedOrderEnum {
  Asc = 'asc',
  Desc = 'desc',
}

export enum MarqCommonEnumsClientBusinessType {
  Individual = 'individual',
  Corporate = 'corporate',
}

export enum MarqCommonEnumsIpTrademarkTypeEnum {
  Word = 'word',
  Logo = 'logo',
  Composite = 'composite',
  DesignRight = 'designRight',
}

export enum MarqCommonEnumsPaymentCardBrandEnum {
  Visa = 'visa',
  Mastercard = 'mastercard',
  Discover = 'discover',
  Jcb = 'jcb',
  Unionpay = 'unionpay',
  Diners = 'diners',
  Amex = 'amex',
  Unknown = 'unknown',
}

export enum MarqCommonEnumsPaymentPaymentMethodEnum {
  Card = 'card',
  BankTransfer = 'bank_transfer',
}

export interface MarqCommonModelCard {
  brand: MarqCommonEnumsPaymentCardBrandEnum;
  lastFour: string;
  paymentMethodId: string;
}

export interface MyappDocumentsProtocolDeleteAttachmentRequest {
  /** @format int32 */
  attachmentId: number;
  /** @format int32 */
  formId: number;
  formType: FolioCommonEnumsFormTypeEnum;
}

export interface MyappDocumentsProtocolDeleteQnaSelectionRequest {
  /** @format int32 */
  formId: number;
  isOther: boolean;
  /** @format int32 */
  selectionId?: number | null;
}

export interface MyappDocumentsProtocolGetAttachmentDownloadUrlRequest {
  url: string;
}

export interface MyappDocumentsProtocolGetAttachmentDownloadUrlResponse {
  url: string;
}

export interface MyappDocumentsProtocolGetAttachmentPresignedUrlRequest {
  countryCode: FolioCommonEnumsFolioCountryCodeEnum;
  filename: string;
  /** @format int32 */
  tmId: number;
}

export interface MyappDocumentsProtocolGetAttachmentPresignedUrlResponse {
  url: string;
}

export interface MyappDocumentsProtocolGetCtryListRequest {
  /** @format int32 */
  tmId: number;
}

export interface MyappDocumentsProtocolGetCtryListResponse {
  count: MyappDocumentsProtocolGetCtryListResponseCount;
  countryList: FolioCommonModelTmFormsStatusFormStatusByCtry[];
}

export interface MyappDocumentsProtocolGetCtryListResponseCount {
  /** @format int32 */
  completed: number;
  /** @format int32 */
  total: number;
}

export interface MyappDocumentsProtocolGetDocQnaListRequest {
  countryCode: FolioCommonEnumsFolioCountryCodeEnum;
  /** @format int32 */
  tmId: number;
}

export interface MyappDocumentsProtocolGetDocQnaListResponse {
  list: FolioCommonModelTmFormDto[];
  partner: string;
}

export interface MyappDocumentsProtocolSaveAttachmentRequest {
  attachment: FolioCommonModelAttachment;
  /** @format int32 */
  formId: number;
  formType: FolioCommonEnumsFormTypeEnum;
}

export interface MyappDocumentsProtocolSaveDocPoaMailRequest {
  alreadySubmitted: boolean;
  /** @format int32 */
  formId: number;
}

export interface MyappDocumentsProtocolSaveDocPoaSignRequest {
  agreementId: string;
  /** @format int32 */
  formId: number;
}

export interface MyappDocumentsProtocolSaveQnaChosenDateRequest {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  date?: string | null;
  /** @format int32 */
  formId: number;
}

export interface MyappDocumentsProtocolSaveQnaReplyRequest {
  /** @format int32 */
  formId: number;
  reply: string;
}

export interface MyappDocumentsProtocolSaveQnaSelectionRequest {
  /** @format int32 */
  formId: number;
  other?: string | null;
  /** @format int32 */
  selectionId?: number | null;
}

export interface MyappMyAppProtocolDeleteAppRequest {
  /** @format int32 */
  tmId: number;
}

export interface MyappMyAppProtocolGetApplicantRequest {
  /** @format int32 */
  id: number;
}

export interface MyappMyAppProtocolGetApplicantResponse {
  businessType?: MarqCommonEnumsClientBusinessType;
  companyCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  companyName?: string | null;
  email?: string | null;
  ownerFirstName?: string | null;
  ownerLastName?: string | null;
  ownerNationality?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneCountry?: FolioCommonEnumsFolioCountryCodeEnum;
  phoneNumber?: string | null;
}

export interface MyappMyAppProtocolGetApplicationStatusRequest {
  /** @format int32 */
  id: number;
}

export interface MyappMyAppProtocolGetApplicationStatusResponse {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expectedCompletionDate?: string | null;
  hasDoc: boolean;
  stage: FolioCommonEnumsApplicationStageEnum;
  status: FolioCommonEnumsApplicationStatusEnum;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  submittedDate?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updatedDate: string;
}

export interface MyappMyAppProtocolGetDetailRequest {
  /** @format int32 */
  id: number;
}

export interface MyappMyAppProtocolGetDetailResponse {
  description?: string | null;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expectedCompletionDate?: string | null;
  paySummary: FolioCommonModelTmPricePack;
  paymentKind: FolioCommonEnumsPaymentKindEnum;
  reference?: FolioCoreModelApTmReferenceDto;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  submittedDate?: string | null;
  tmUsage?: FolioCoreModelApTmUsageDto;
  trademark?: FolioCommonModelTrademarkDto;
}

export interface MyappMyAppProtocolGetDownloadInvoiceRequest {
  /** @format int32 */
  id: number;
}

export interface MyappMyAppProtocolGetDownloadInvoiceResponse {
  /** @format int32 */
  paymentId: number;
  url: string;
}

export interface MyappMyAppProtocolGetFileDownloadUrlRequest {
  url: string;
}

export interface MyappMyAppProtocolGetFileDownloadUrlResponse {
  downloadUrl: string;
}

export interface MyappMyAppProtocolGetGroupListRequest {
  /** @format int32 */
  tmId: number;
}

export interface MyappMyAppProtocolGetGroupListResponse {
  list: MyappMyAppProtocolGetGroupListResponseTmGroup[];
}

export interface MyappMyAppProtocolGetGroupListResponseGroupList {
  classIdList: number[];
  /** @format int32 */
  groupId: number;
}

export interface MyappMyAppProtocolGetGroupListResponseRecoveryList {
  name?: string | null;
  /** @format int32 */
  recoveryId: number;
}

export interface MyappMyAppProtocolGetGroupListResponseTmGroup {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  groupList: MyappMyAppProtocolGetGroupListResponseGroupList[];
  recoveryList?: MyappMyAppProtocolGetGroupListResponseRecoveryList[] | null;
}

export interface MyappMyAppProtocolGetListRequest {
  sortOrder: MarqCommonEnumsSortedOrderEnum;
  sortedBy: FolioCommonEnumsMyAppSorted;
}

export interface MyappMyAppProtocolGetListResponse {
  appList: MyappMyAppProtocolGetListResponseApplication[];
}

export interface MyappMyAppProtocolGetListResponseApplication {
  additionalPayReqIdList?: number[] | null;
  applicationEdited: MyappMyAppProtocolGetListResponseApplicationEdited;
  applicationStatus: FolioCoreModelApStatusSectionDto;
  docQnaSubmit: MyappMyAppProtocolGetListResponseDocQnaSubmit;
  docReview: MyappMyAppProtocolGetListResponseDocReview;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  expectedCompletionDate?: string | null;
  expired: boolean;
  hasAdditionalPayReq: boolean;
  hasPayReq: boolean;
  /** @format int32 */
  id: number;
  newChat?: MyappMyAppProtocolGetListResponseNewChat;
  statusUpdated?: MyappMyAppProtocolGetListResponseStatusUpdated;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  submittedDate?: string | null;
  summary: MyappMyAppProtocolGetListResponseSummary;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  updatedDate?: string | null;
}

export interface MyappMyAppProtocolGetListResponseApplicationEdited {
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  lastEditedDate?: string | null;
  showNoti: boolean;
}

export interface MyappMyAppProtocolGetListResponseDocQnaSubmit {
  countryCode?: FolioCommonEnumsFolioCountryCodeEnum;
  needed: boolean;
}

export interface MyappMyAppProtocolGetListResponseDocReview {
  countryCode?: FolioCommonEnumsFolioCountryCodeEnum;
  needed: boolean;
}

export interface MyappMyAppProtocolGetListResponseNewChat {
  countryList: FolioCommonEnumsFolioCountryCodeEnum[];
  from?: string | null;
}

export interface MyappMyAppProtocolGetListResponseStatusUpdated {
  countryList: FolioCommonEnumsFolioCountryCodeEnum[];
}

export interface MyappMyAppProtocolGetListResponseSummary {
  classList?: string[] | null;
  countryList: FolioCommonEnumsFolioCountryCodeEnum[];
  imageUrl?: string | null;
  word?: string | null;
}

export interface MyappMyAppProtocolGetNoteDownloadUrlRequest {
  url: string;
}

export interface MyappMyAppProtocolGetNoteDownloadUrlResponse {
  url: string;
}

export interface MyappMyAppProtocolGetRecoveryHistoryRequest {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  name?: string | null;
  /** @format int32 */
  tmId: number;
}

export interface MyappMyAppProtocolGetRecoveryHistoryResponse {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  list: MyappMyAppProtocolGetRecoveryHistoryResponseStatusItem[];
  name?: string | null;
}

export interface MyappMyAppProtocolGetRecoveryHistoryResponseStatusItem {
  adminNote?: FolioCoreModelAdminNoteAdminNote;
  /**
   * @format date-time
   * @example "2023-03-01T00:00:00Z"
   */
  createdDate: string;
  /** @format int32 */
  historyId: number;
  name?: string | null;
  recoveryStatus: FolioCommonEnumsPreConflictStatusEnum;
  recoveryStep: FolioCommonEnumsPreConflictStepEnum;
}

export interface MyappMyAppProtocolGetRequestRequest {
  countryFilter?: FolioCommonEnumsFolioCountryCodeEnum[] | null;
  /** @format int32 */
  id: number;
  needReplyFilter?: boolean | null;
  sortedBy: MyappMyAppProtocolRequestSorted;
}

export interface MyappMyAppProtocolGetRequestResponse {
  requestList: FolioCoreModelQnaQnaDto[];
}

export interface MyappMyAppProtocolGetRequestCompletedRequest {
  countryFilter?: FolioCommonEnumsFolioCountryCodeEnum[] | null;
  /** @format int32 */
  id: number;
}

export interface MyappMyAppProtocolGetRequestCompletedResponse {
  requestList: FolioCoreModelQnaQnaDto[];
}

export interface MyappMyAppProtocolGetRequestOpenRequest {
  countryFilter?: FolioCommonEnumsFolioCountryCodeEnum[] | null;
  /** @format int32 */
  id: number;
  sortedBy: MyappMyAppProtocolRequestSorted;
}

export interface MyappMyAppProtocolGetRequestOpenResponse {
  new: boolean;
  requestList: FolioCoreModelQnaQnaDto[];
}

export interface MyappMyAppProtocolGetRequestPresignedUrlRequest {
  filename: string;
  /** @format int32 */
  id: number;
}

export interface MyappMyAppProtocolGetRequestPresignedUrlResponse {
  url: string;
}

export interface MyappMyAppProtocolGetStatusByCountryRequest {
  /** @format int32 */
  id: number;
}

export interface MyappMyAppProtocolGetStatusByCountryResponse {
  list: MyappMyAppProtocolGetStatusByCountryResponseCountryStatus[];
}

export interface MyappMyAppProtocolGetStatusByCountryResponseCountryStatus {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  hasAdditionalPayReq: boolean;
  hasRecovery: boolean;
  status: FolioCommonEnumsApplicationStatusEnum;
}

export interface MyappMyAppProtocolGetStatusHistoryRequest {
  country: FolioCommonEnumsFolioCountryCodeEnum;
  /** @format int32 */
  groupId: number;
}

export interface MyappMyAppProtocolPostRequestAnswerFreeRequest {
  fileList: FolioCoreModelFilenameUrl[];
  imageList: FolioCoreModelFilenameUrl[];
  /** @format int32 */
  qnaId: number;
  text: string;
}

export interface MyappMyAppProtocolPostRequestAnswerSelectionRequest {
  other?: string | null;
  /** @format int32 */
  qnaId: number;
  selectedList: number[];
}

export enum MyappMyAppProtocolRequestSorted {
  DueDate = 'due_date',
  CreatedDate = 'created_date',
}
